export const LIST_SLIDER_LIMIT = 12;
export const LIST_SLIDER_OPTIONS = {
    'without-images': {
        itemWidth: {
            mobile: '85.06vw',
            mobileMedium: '85.06vw',
            mobileWide: '319px',
        },
        withSliderBorder: true,
    },
    'with-images': {
        itemWidth: {
            mobile: '80vw',
            mobileMedium: '80vw',
            mobileWide: '300px',
        },
    },
};
